import { onSwipe } from '../../js/utils';

document.querySelectorAll('.image-carousel').forEach(setupCarousel);

function setupCarousel(carousel) {
    const track = carousel.querySelector('.image-carousel__track');
    const items = Array.from(track.children);
    const dotSelector = '.image-carousel__dot';
    const dotNav = carousel.querySelector('.image-carousel__dots');
    const prevBtn = carousel.querySelector('[data-direction="prev"]');
    const nextBtn = carousel.querySelector('[data-direction="next"]');

    const loop = carousel.dataset.loop !== 'false'; // loop is true by default if not set
    let activeIndex = items.findIndex(item => item.getAttribute('aria-hidden') === 'false');

    if (activeIndex === -1) activeIndex = 0;

    const dots = Array.from(dotNav?.querySelectorAll(dotSelector) || []);

    function updateActive(index) {
        const prevIndex = activeIndex;

        if (!loop) {
            if (index < 0 || index >= items.length) return; // Prevent wrapping if loop is off
        }

        activeIndex = (index + items.length) % items.length; // Wrap around if loop is on

        // Update previous slide and dot
        items[prevIndex]?.setAttribute('aria-hidden', 'true');
        items[prevIndex]?.setAttribute('tabindex', '-1');
        dots[prevIndex]?.setAttribute('aria-selected', 'false');
        dots[prevIndex]?.setAttribute('tabindex', '-1');

        // Update current slide and dot
        items[activeIndex].setAttribute('aria-hidden', 'false');
        items[activeIndex].setAttribute('tabindex', '0');
        dots[activeIndex]?.setAttribute('aria-selected', 'true');
        dots[activeIndex]?.setAttribute('tabindex', '0');

        updateButtonStates();
    }
  
    // Update prev/next buttons based on the loop state
    function updateButtonStates() {
        if (!loop) {
            if (prevBtn) {
                prevBtn.disabled = activeIndex === 0;
                prevBtn.setAttribute('aria-disabled', prevBtn.disabled);
            }
            
            if (nextBtn) {
                nextBtn.disabled = activeIndex === items.length - 1;
                nextBtn.setAttribute('aria-disabled', nextBtn.disabled);
            }
        }
    }
  
    // Prev/Next buttons event handlers
    prevBtn?.addEventListener('click', () => updateActive(activeIndex - 1));
    nextBtn?.addEventListener('click', () => updateActive(activeIndex + 1));

    // Swipe support (left/right swipe)
    onSwipe(track, {
        onSwipeLeft: () => updateActive(activeIndex + 1),
        onSwipeRight: () => updateActive(activeIndex - 1),
    });

    // Arrow key support on track
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') updateActive(activeIndex - 1);
        if (e.key === 'ArrowRight') updateActive(activeIndex + 1);
    });

    // Event delegation: dot click (for navigation)
    dotNav?.addEventListener('click', (e) => {
        const dot = e.target.closest(dotSelector);
        if (!dot) return;
        const index = parseInt(dot.dataset.index, 10);
        if (!isNaN(index)) updateActive(index);
    });

    // Event delegation: dot keyboard navigation (left/right arrows to navigate, Enter/Space to select)
    dotNav?.addEventListener('keydown', (e) => {
        const dot = e.target.closest(dotSelector);
        if (!dot) return;

        const currentIndex = parseInt(dot.dataset.index, 10);
        let nextDot;
  
        if (e.key === 'ArrowRight') {
            nextDot = dotNav.querySelector(`.image-carousel__dot[data-index="${(currentIndex + 1) % dots.length}"]`);
        } else if (e.key === 'ArrowLeft') {
            nextDot = dotNav.querySelector(`.image-carousel__dot[data-index="${(currentIndex - 1 + dots.length) % dots.length}"]`);
        } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            updateActive(currentIndex);
            return;
        }

        if (nextDot) {
            nextDot.focus();
        }
    });
  
    // Ensure initial state is correct
    updateActive(activeIndex);
}
